import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Background } from "@/components/Background";
import { Navbar } from "@/components/Navbar";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthCallback } from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import CreateListing from "@/pages/CreateListing";
import Dashboard from "@/pages/Dashboard";
import TradeRoom from "@/pages/TradeRoom";
import Auth from "@/pages/Auth";
import Admin from "@/pages/Admin";
import AdminMembers from "@/pages/AdminMembers";
import Wallet from "@/pages/Wallet";
import Profile from "@/pages/Profile";
import Membership from "@/pages/Membership";
import Leaderboard from "@/pages/Leaderboard";
import Support from "@/pages/Support";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/listing/:id" element={<ListingDetail />} />
        <Route path="/user/:id" element={<Profile />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/create" element={<ProtectedRoute memberOnly><CreateListing /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute memberOnly><Dashboard /></ProtectedRoute>} />
        <Route path="/membership" element={<ProtectedRoute><Membership /></ProtectedRoute>} />
        <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
        <Route path="/trade/:offerId" element={<ProtectedRoute memberOnly><TradeRoom /></ProtectedRoute>} />
        <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="/admin/members" element={<ProtectedRoute adminOnly><AdminMembers /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <Background />
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
